module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_2stars@3x.a92789e4.png";